import { DATA_SECTIONS, type DataDatasetMeta, type DataSection } from './types'

export type { DataDataset, DataDatasetMeta, DataSection } from './types'
export { DATA_SECTIONS } from './types'
export { DataDatasetProvider } from './DataDatasetProvider'
export { useActiveDataset, useActiveRunInfo } from './dataset-context'

/**
 * Maps Data module URL paths to the section they belong to. Used by the
 * sidebar and route guards to gate visibility based on the sections enabled
 * by the organization's latest run.
 *
 * Routes not listed here (or new routes added later that aren't mapped) fall
 * back to "always visible" — only routes explicitly tied to an optional
 * section are gated.
 */
export const DATA_ROUTE_TO_SECTION: Readonly<Record<string, DataSection>> = {
  '/data/dashboard': DATA_SECTIONS.DASHBOARD,
  '/data/prompts': DATA_SECTIONS.PROMPTS,
  '/data/prompts/responses': DATA_SECTIONS.PROMPTS,
  '/data/sources': DATA_SECTIONS.SOURCES,
  '/data/actions': DATA_SECTIONS.ACTIONS,
}

type SectionGate = Pick<DataDatasetMeta, 'sections'>

export function isDataSectionEnabled(dataset: SectionGate, section: DataSection): boolean {
  return dataset.sections.includes(section)
}

export function isDataRouteEnabled(dataset: SectionGate, path: string): boolean {
  const section = DATA_ROUTE_TO_SECTION[path]
  if (!section) return true
  return isDataSectionEnabled(dataset, section)
}
